/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const personSummaryDataLastActivityLabelSchema = z.enum(['messaged', 'stage_moved', 'applied', 'interview'])

export type PersonSummaryDataLastActivityLabelSchema = z.infer<typeof personSummaryDataLastActivityLabelSchema>
